"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * DataTableCell
 *
 */
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var CheckCircle_1 = __importDefault(require("@mui/icons-material/CheckCircle"));
var Cancel_1 = __importDefault(require("@mui/icons-material/Cancel"));
var material_1 = require("@mui/material");
var dompurify_1 = __importDefault(require("dompurify"));
var crude_selector_1 = require("../../store/crude/crude.selector");
var getDefaultFormat_1 = require("../../defaults/getDefaultFormat");
var formatDate_1 = __importDefault(require("../../shared/util/formatDate"));
var react_router_1 = require("react-router");
var crudeActions = __importStar(require("../../store/crude/crude.actions"));
var crude_actions_1 = require("../../store/crude/crude.actions");
var CrudeThumbnailComponent_1 = __importDefault(require("./Components/CrudeThumbnailComponent"));
var styles_1 = require("@mui/styles");
var formatCurrency_1 = __importDefault(require("../../shared/util/formatCurrency"));
var getPinPosition_1 = __importDefault(require("../../shared/util/getPinPosition"));
var commonTypes_1 = require("../../shared/types/commonTypes");
var TooltipComponent_1 = __importDefault(require("../../shared/components/MessageComponents/TooltipComponent"));
var DataTableCell = function (props) {
    var _a, _b, _c, _d;
    var crudeConfig = react_redux_1.useSelector(crude_selector_1.getCrudeConfiguration);
    var crudeLicense = react_redux_1.useSelector(crude_selector_1.getCrudeLicense);
    var screenDesign = react_redux_1.useSelector(crude_selector_1.getScreenDesign);
    // manage Licenses
    var extendedTableLicense = crudeLicense.extendedTable.available;
    var useStyles = styles_1.makeStyles(function (theme) {
        var _a;
        return ({
            content: {
                overflow: 'hidden',
                display: '-webkit-box',
                '-webkit-line-clamp': (screenDesign === commonTypes_1.ScreenDesign.mobile) ? 1 : (extendedTableLicense && ((_a = crudeConfig.appLayout) === null || _a === void 0 ? void 0 : _a.maxTextLinesInTableView)),
                '-webkit-box-orient': 'vertical',
            },
            cell: {
                backgroundColor: 'inherit',
            },
        });
    });
    var history = react_router_1.useHistory();
    var classes = useStyles();
    var dispatch = react_redux_1.useDispatch();
    var appLayout = react_redux_1.useSelector(crude_selector_1.getAppLayout);
    var crudePath = react_redux_1.useSelector(crude_selector_1.getCrudePath) || '';
    var crudeLanguage = react_redux_1.useSelector(crude_selector_1.getLanguage);
    var crudeLabels = react_redux_1.useSelector(crude_selector_1.getCrudeLabels)[crudeLanguage];
    var crudeSchema = react_redux_1.useSelector(crude_selector_1.getCrudeSchema);
    var crudeTabs = react_redux_1.useSelector(crude_selector_1.getCrudeTabs);
    var templateObject = extendedTableLicense && appLayout.tableTemplates && appLayout.tableTemplates.find(function (tableTemplate) { var _a; return tableTemplate.entity === props.entity && tableTemplate.column === ((_a = props.column) === null || _a === void 0 ? void 0 : _a.name); });
    var maxForeignReferenceJumpLevel = extendedTableLicense ? appLayout.maxForeignReferenceJumpLevel : undefined;
    var foreignKeyJumpAllowed = !!((typeof props.treeViewLevel === 'number' && maxForeignReferenceJumpLevel && maxForeignReferenceJumpLevel >= props.treeViewLevel));
    var entity = props.entity;
    var entitySchema = crudeSchema && crudeSchema.find(function (entitySchema) { return entitySchema.name === entity; });
    var content = props.dataViewType && props.dataViewType === commonTypes_1.DataViewType.referenceView
        ? react_1.default.createElement("div", { className: classes.content, dangerouslySetInnerHTML: { __html: dompurify_1.default.sanitize(props.content) } })
        : props.content;
    if (props.column) {
        var dateTime = props.content;
        if (props.column.columnType === 'Time') {
            content = formatDate_1.default(dateTime, getDefaultFormat_1.Format.time);
        }
        if (props.column.columnType === 'Date') {
            content = formatDate_1.default(dateTime, getDefaultFormat_1.Format.date);
        }
        if (props.column.columnType === 'DateTime') {
            content = formatDate_1.default(dateTime, getDefaultFormat_1.Format.dateTime);
        }
        if (props.column.columnType === 'Boolean') {
            content = props.content ? react_1.default.createElement(CheckCircle_1.default, null) : react_1.default.createElement(Cancel_1.default, null);
        }
        if (props.column.columnType === 'Enum') {
            var columnLabels = (_b = (_a = crudeLabels === null || crudeLabels === void 0 ? void 0 : crudeLabels.app[crudeConfig.api.app]) === null || _a === void 0 ? void 0 : _a.entity[entity]) === null || _b === void 0 ? void 0 : _b.columns;
            content = columnLabels ? (_d = (_c = columnLabels[props.column.name]) === null || _c === void 0 ? void 0 : _c.options[props.content]) === null || _d === void 0 ? void 0 : _d.title : props.content;
        }
        if (props.column.columnType === 'Files') {
            var thumbnails = props.thumbnailData[props.id][props.column.name];
            content = react_1.default.createElement(CrudeThumbnailComponent_1.default, { thumbnails: thumbnails, schema: props.column, content: props.content });
        }
        if (props.column.columnType === 'HtmlRichText') {
            content = react_1.default.createElement("div", { className: classes.content, dangerouslySetInnerHTML: { __html: dompurify_1.default.sanitize(props.content) } });
        }
        if (props.column.columnType === 'String') {
            content = react_1.default.createElement("div", { className: classes.content }, props.content);
        }
        // todo erweiterung auf andere formate nötig
        if (templateObject) {
            if (templateObject.template.search('formatCurrency') !== -1) {
                content = templateObject.template.replace("formatCurrency({{data:" + props.column.name + "}})", formatCurrency_1.default(parseFloat(props.content)));
            }
            else {
                content = templateObject.template.replace("{{data:" + props.column.name + "}}", props.content);
            }
        }
    }
    var _e = react_1.useState(), outgoingReference = _e[0], setOutgoingReference = _e[1];
    react_1.useEffect(function () {
        // wenn Fremdschlüssel in der Zelle sind, label aus den previews nehmen
        entitySchema === null || entitySchema === void 0 ? void 0 : entitySchema.outgoingReferences.forEach(function (reference) {
            var id = props.content;
            if (reference.targetEntity && props.content && props.column && reference.sourceColumn === props.column.name) {
                setOutgoingReference(react_1.default.createElement("div", { className: classes.content, dangerouslySetInnerHTML: { __html: dompurify_1.default.sanitize(props.entityReferencePreviews[reference.targetEntity][id]) } }));
            }
        });
    }, []);
    var editEntity = function () {
        if (outgoingReference && foreignKeyJumpAllowed) {
            entitySchema === null || entitySchema === void 0 ? void 0 : entitySchema.outgoingReferences.forEach(function (reference) {
                var id = props.content;
                if (reference.targetEntity && props.content && props.column && reference.sourceColumn === props.column.name) {
                    var newPath = crudePath + "/" + reference.targetEntity + "/" + id;
                    var tab = crudeTabs && crudeTabs.findIndex(function (tab) { return tab.entity === reference.targetEntity; });
                    tab && dispatch(crudeActions.setActiveTab(tab));
                    dispatch(crude_actions_1.setActiveEntity(reference.targetEntity));
                    dispatch(crude_actions_1.setLastActiveEntity(props.entity));
                    history.push(newPath);
                }
            });
        }
    };
    var Cell = react_1.default.useMemo(function () {
        var _a, _b;
        return (react_1.default.createElement(material_1.TableCell, { align: props.align, sx: props.pinned && props.column && entitySchema ? getPinPosition_1.default(props.entityColumns, (_a = props.column) === null || _a === void 0 ? void 0 : _a.name, entitySchema) : { backgroundColor: 'inherit' }, className: classes.cell, style: (outgoingReference && foreignKeyJumpAllowed) ? { cursor: 'pointer', padding: '6px 16px', backgroundColor: 'inherit' } : { cursor: 'default', padding: '6px 16px' }, onClick: function () { return editEntity(); }, key: "DataTableCell" + props.id + (props.column && props.column.name), children: react_1.default.createElement(react_1.default.Fragment, null, extendedTableLicense && ((_b = crudeConfig.appLayout) === null || _b === void 0 ? void 0 : _b.maxTextLinesInTableView) ? (react_1.default.createElement(TooltipComponent_1.default, { title: (outgoingReference || content), placement: 'bottom-start', element: react_1.default.createElement(react_1.default.Fragment, null, outgoingReference || content) }))
                : react_1.default.createElement(react_1.default.Fragment, null, outgoingReference || content)) }));
    }, [outgoingReference]);
    return (react_1.default.createElement(react_1.default.Fragment, null, Cell));
};
exports.default = DataTableCell;
